import { useState } from 'react';
import { queryUpdateParker } from '../Queries';
import featureFlags from '../featureFlags'

const parkerQueryFields = [
  'id',
  'suspension_status',
  'termination_status',
  'access_system_status',
  'rate_id'
]

function useUpdateRate(subscriptionId, parker, callback) {
  // make a call to queryUpdateParker with the rate and update the rate using the subscriptionId and parkerId
  const [currentRate, setCurrentRate] = useState(parker.fields.rate_id.value);
  const [errorMessage, setErrorMessage] = useState(null);
  const [inProgress, setInProgress] = useState(false);

  const updatedParker = {
    ...parker.getQueryFieldValues(),
    rate_id: currentRate
  }

  const updateRate = async () => {
    setInProgress(true);
    setErrorMessage(null);

    delete updatedParker.parker_status_history;

    try {
      const { data, errors } = await queryUpdateParker({
        subscription_id: subscriptionId,
        parker: updatedParker,
      }, parkerQueryFields);

      if (errors) {
        throw new Error(errors.map(({ message }) => message));
      }

      const { suspension_status, termination_status, access_system_status, rate_id } = data.updateParker;

      callback({ suspension_status, termination_status, access_system_status, rate_id });
      

    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setInProgress(false);
    }
  }

  return {
    currentRate,
    setCurrentRate,
    inProgress,
    setInProgress,
    errorMessage,
    updateRate
  };
}

export default useUpdateRate;
